import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import PromptGenerator from './components/PromptGenerator';
import BlogCreator from './components/BlogCreator';
import CarouselBuilder from './components/CarouselBuilder';
import CaptionGenerator from './components/CaptionGenerator';
import MediaKit from './components/MediaKit';
import TikTokScript from './components/TikTokScript';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage';
import './App.css';

const RedirectToHome = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/');
  }, [navigate]);
  return null;
};

function App() {
  const [generatedPrompt, setGeneratedPrompt] = useState('');
  const [promptData, setPromptData] = useState({
    location: 'Santorini',
    vibe: 'Cultural Immersion',
    travelerType: 'Solo',
    ageGroup: 'Adult (25-64)',
    gender: 'Non-binary',
    lgbtqIdentity: 'Ally',
    mobility: 'None',
    accessibility: 'Standard Access',
    experience: 'Local Market Exploration',
    pose: 'Engaged with local culture',
    culturalContext: 'Respectful Tourism',
    outputType: 'static'
  });

  // Load saved prompt and data from localStorage
  useEffect(() => {
    try {
      const savedPrompt = localStorage.getItem('generatedPrompt');
      const savedData = localStorage.getItem('promptData');
      if (savedPrompt) {
        setGeneratedPrompt(savedPrompt);
      }
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        setPromptData(prev => ({ ...prev, ...parsedData }));
      }
    } catch (error) {
      console.error('Error loading saved data:', error);
    }
  }, []);

  // Save prompt and data to localStorage whenever they change
  useEffect(() => {
    try {
      if (generatedPrompt) {
        localStorage.setItem('generatedPrompt', generatedPrompt);
      }
      if (Object.keys(promptData).length > 0) {
        localStorage.setItem('promptData', JSON.stringify(promptData));
      }
    } catch (error) {
      console.error('Error saving data:', error);
    }
  }, [generatedPrompt, promptData]);

  const handlePromptGenerated = (prompt) => {
    console.log('New prompt generated:', prompt);
    setGeneratedPrompt(prompt);
  };

  const handleDataChanged = (data) => {
    console.log('New data:', data);
    setPromptData(prev => ({ ...prev, ...data }));
  };

  // Debug log for render
  useEffect(() => {
    console.log('Current prompt:', generatedPrompt);
    console.log('Current data:', promptData);
  }, [generatedPrompt, promptData]);

  return (
    <Router>
      <div className="min-h-screen bg-gray-900 text-white">
        <Navigation />
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Dashboard generatedPrompt={generatedPrompt} promptData={promptData} />} />
            <Route path="/generator" element={<PromptGenerator onPromptGenerated={handlePromptGenerated} onDataChanged={handleDataChanged} initialPrompt={generatedPrompt} initialData={promptData} />} />
            <Route path="/blog" element={<BlogCreator prompt={generatedPrompt} data={promptData} />} />
            <Route path="/carousel" element={<CarouselBuilder prompt={generatedPrompt} data={promptData} />} />
            <Route path="/captions" element={<CaptionGenerator prompt={generatedPrompt} data={promptData} />} />
            <Route path="/media-kit" element={<MediaKit prompt={generatedPrompt} data={promptData} />} />
            <Route path="/tiktok" element={<TikTokScript prompt={generatedPrompt} data={promptData} />} />
            <Route path="/landing" element={<LandingPage prompt={generatedPrompt} data={promptData} />} />
            <Route path="*" element={<RedirectToHome />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;